import React, { useEffect, useState, useContext } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import { checkUserPermission } from "../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useMemo } from "react";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../common/common";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import { AppContext } from "../../../context/AppContext";
import { event } from "jquery";
import { Noimage } from "../../../common/imagePath";
import CurrencySymbols from "../../../common/CurrencySymbol";

function PaymentLog() {
  const { CurrencySymbol, FractionDigits, isManageSale, isManagePOSSale, dateFormate, isManageReceiving, isManagePOSReceiving } = useContext(AppContext);
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");

  const searchParams = new URLSearchParams(window.location.search);
  let iParam = searchParams.get("ttid") || 0;

  const [formValues, setFormValues] = useState([]);

  const [perPageSize, setperPageSize] = useState(25);
  const [searchtext, setSearchText] = useState("");
  const [sortingId, setSortingId] = useState(1); //currentorder
  const [sortingDirection, setSortingDirection] = useState("desc"); // ordercolumn

  const [loading, setLoading] = useState(false);
  const [isFirstTimeCall, setIsFirstTimeCall] = useState(1);
  const [supplier, setSupplier] = useState([]);
  const [payee, setPayee] = useState([]);
  const [accountslist, setAccountsList] = useState([]);
  const [selectedPayee, setSelectedPayee] = useState({
    value: 0,
    payeeType: 0,
  });
  const [itemIds, setItemIds] = useState({
    ItemId: 0,
    variationId: 0,
    itemName: "",
  });

  const [textFieldsData, setTextFieldsData] = useState({
    refrenceno: "",
    Amount: "",
    Memo: "",
    maxamount: "",
  });

  console.log(itemIds, "itemIds");
  const [selectSupplier, setSelectSupplier] = useState(0);
  const [selectEmployee, setSelectEmployee] = useState(0);
  const [customer, setCustomer] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(0);
  const [accountId, setAccountId] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  const [searchItemName, setSearchItemName] = useState("");
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [conditionId, setConditionId] = useState(1);

  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);
  const [selectTransaction, setSelectTransaction] = useState(iParam || 1);

  const [customeDate, setCustomDate] = useState(9);

  const [showSupplierSelect, setShowSupplierSelect] = useState(true);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);
  const [ShowEmployeeSelect, setShowEmployeeSelect] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 150,
  });

  console.log(isFirstTimeCall,"paginationcheck")

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  let PERMISSION_EDIT = "edit-transaction-log";

  // Permission paths
  let SHOWPAYMENTS = "/show-receive-payments";
  let SHOWPAYBILLS = "/show-paybill";
  let SHOWJOURNALS = "/journals";
  let SHOWDEPOSITS = "/show-bank-deposit";
  let SHOWBANKTRANSFER = "/transfer";
  let SHOWEXPENSE = "/show-expense";

  let EDITPAYMENTS = "/receive-payment/:id";
  let EDITPAYBILLS = "/receiving-paybills/:id";
  let EDITJOURNALS = "/journal-entry/:id";
  let EDITDEPOSITS = "/bank-deposit/:id";
  let EDITBANKTRANSFER = "/manage-transfer/:id";
  let EDITEXPENSE = "/Expense/:id";

  const transactionTypeToPermissionMap = {
    "Receive Payment": "/show-receive-payments",
    "Bill Payments": "/show-paybill",
    "Journal Entry": "/journals",
    "Deposit": "/show-bank-deposit",
    "Bank Transfer": "/transfer",
    "Expense": "/show-expense",
    "CC Expense": "/show-expense",
    "CC Credit": "/show-expense",
    "Check": "/show-expense",
    // Add more mappings if needed
  };



  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const startLast7DayDate = moment()
    .subtract(6, "days")
    .startOf("day")
    .format("YYYY-MM-DD");
  const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");

  const [beginningDate, setBeginningDate] = useState(""); //startLast7DayDate

  console.log(beginningDate, "beginningDate------>");
  const [finalDate, setFinalDate] = useState(""); //endLast7DayDate

  useEffect(() => {
    if (customeDate === 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    }
  }, []);

  const navigate = useNavigate();

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const dateOptions = [
    { label: "Select", value: 0 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    { label: "Last 7 Day", value: 8 },
    { label: "All", value: 9 },
  ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size: 100,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <>
              <Box
                component="span"
                sx={(theme) => ({
                  borderRadius: "0.3rem",
                  color: "#343f62",
                  maxWidth: "18ch",
                  fontWeight: "700",
                  textDecoration: "underline",
                  textUnderlineOffset: "3px",
                  p: "0.3rem",
                  cursor: "pointer",
                })}
              >
                <span
            style={{
              display: "inline-block",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: (row.original.SyncStatus === "Failed" && row.original.SyncStatus !== "Opening Balance") ? "red" : "green",
              marginRight: "8px",
            }}
            ></span>
                {row?.original?.Type === "Expense" && checkUserPermission(EDITEXPENSE)? (
                  <Link
                    to={`/Expense/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "RECEIVINGS"  ? (
                  <Link to={`/receiving-receipt/${row.original.ID}`} style={{ color: "#000" }} >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "DEPOSIT" && checkUserPermission(EDITDEPOSITS) ? (
                  <Link
                    to={`/bank-deposit/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "TRANSFER"  && checkUserPermission(EDITBANKTRANSFER) ? (
                  <Link
                    to={`/manage-transfer/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "JOURNAL" && checkUserPermission(EDITJOURNALS) ? (
                  <Link
                    to={`/journal-entry/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "PAYBILLS" && checkUserPermission(EDITPAYBILLS) ? (
                  <Link
                    to={`/receiving-paybills/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "RECEIVEPAYMENT" && checkUserPermission(EDITPAYMENTS) ? (
                  <Link
                    to={`/receive-payment/${row.original.ID}`}
                    style={{ color: "#000" }}
                  >
                    {row?.original.ID}
                  </Link>
                ) : row?.original?.Module === "SALES" ? (
                  <Link to={`/sales-receipt/${row.original.ID}`} style={{ color: "#000" }}>
                    {row?.original.ID}
                  </Link>
                ) : (
                  <div>{row?.original.ID}</div>
                )}
              </Box>
            </>
          )
        : null,
    },
    {
      header: "DATE",
      accessorKey: "Date",
      size: 110,
      Cell: ({ row }) =>
        row.original.Date == "0000-00-00" ||
        row.original.Date == "" ||
        row.original.Date == null
          ? ""
          : moment(row.original.Date).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "TYPE",
      accessorKey: "Type",
      size: 120,
      Cell: ({ row }) => {
        let txnType = row.original.IsCheck == 1 ? "Check" : row.original.Type;
        return txnType
      }
    },
    {
      header: " BILL / REF NO.",
      accessorKey: "No",
      size: 120,
    },
    {
      header: "CONTACT",
      accessorKey: "Contact",
      // size: 120,
      Cell: ({ row }) => (
        <>
          {row?.original.IsSupplier === 1 && row?.original.SupCusId !== null ? (
            <Link
              to={`/manage-suppliers/${row?.original.SupCusId}`}
              style={{
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              }}
            >
              {row?.original.Contact}
            </Link>
          ) : row?.original.IsSupplier === 2 &&
            row?.original.SupCusId !== null ? (
            <Link
              to={`/manage-customers/${row?.original.SupCusId}`}
              style={{
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              }}
            >
              {row?.original.Contact}
            </Link>
          ) : (
            <div>{row?.original.Contact}</div>
          )}
        </>
      ),
    },
    {
      header: "AMOUNT / CREDIT",
      accessorKey: "Amount",
      size: 130,
      Cell: ({ row }) => {
        return (
          <div>
            <p>{CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits)}</p>
            {/* <p>{parseFloat(row?.original?.Amount).toFixed(2)}</p> */}
            {/* <p>Credit: {parseFloat(row?.original?.Credit).toFixed(2)}</p> */}
            {row?.original?.Credit == 0 ? (
              ""
            ) : (
              <>
                <p>Credit: {CurrencySymbols(
              Number(row.original.Credit),
              { CurrencySymbol },
              FractionDigits)}</p>
              </>
            )}
          </div>
        );
      },
    },
    {
      header: "CATEGORY",
      size: 140,
      accessorKey: "SplitRecords",
      Cell: ({row}) => row.original.IsSplit === 1 ? "--Split--" :  (row.original.SplitRecords ? row.original.SplitRecords?.split(" : ")[0] : "")
      
    },
    {
      header: "ACCOUNT",
      size: 150,
      accessorKey: "AccountName",
    },
    
    {
      header: "MEMO / DESC.",
      size: 120,
      accessorKey: "Memo",
    },
    {
      header: "DUE DATE",
      accessorKey: "DueDate",
       size: 110,
      Cell: ({ row }) => {
        return row?.original?.DueDate == null ||
          row?.original?.DueDate == "00-00-0000" ||
          row?.original?.DueDate == ""
          ? ""
          : moment(row?.original?.DueDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "CREDIT USED",
      accessorKey: "CreditUsed",
       size: 130,
       Cell: ({ row }) => {
    return CurrencySymbols(
      Number(row.original.CreditUsed),
      CurrencySymbol,
      FractionDigits
    );
    // Or, if `CurrencySymbol` and `FractionDigits` are part of an object, adjust like below:
    // return CurrencySymbols(Number(row.original.CreditUsed), { CurrencySymbol }, FractionDigits);
  },
    },
    {
      header: "MODIFIED",
      accessorKey: "LastModifiedDate",
       size : 140,
      Cell: ({ row }) => {
        return row?.original?.LastModifiedDate == null
          ? ""
          : moment(row?.original?.LastModifiedDate).format(`${dateFormate.toUpperCase()} h:mm A`);
      },
    },
    {
      header: "Modified By",
      size: 150,
      accessorKey: "ModifiedBy",
    },
    {
      header: "CREATED ON",
      accessorKey: "CreatedOn",
       size : 140,
      Cell: ({ row }) =>
        moment(row.original.CreatedOn).format(`${dateFormate.toUpperCase()} h:mm A`),
    },
    {
      header: "Created By",
      size: 150,
      accessorKey: "CreatedBy",
    },
    {
      header: "QB SYNC",
      accessorKey: "SyncStatus",
      size: 140,
      Cell: ({ row }) => {
        if (row.original.SyncStatus === "Complete") {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--success-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else if (
          row.original.SyncStatus === "Failed" &&
          row.original.StatusName !== "Opening Balance"
        ) {
          return (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "var(--error-main-color)",
                maxWidth: "9ch",
                p: "0.3rem",
                fontWeight: "bold",
              })}
            >
              {row.original.SyncStatus}
            </Box>
          );
        } else {
          return null;
        }
      },
    },
  ]);

  // Option Set Date
  const handleDateFilter = (event) => {
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == 8) {
      setBeginningDate(startLast7DayDate);
      setFinalDate(endLast7DayDate);
    } else if (event?.value == 9) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  const handleDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      setBeginningDate(selectedDate);
      setCustomDate(7);
    }
  };

  const handleEndDate = (selecttime) => {
    if (selecttime && selecttime.length > 0) {
      setFinalDate(selecttime);
      setCustomDate(7);
    }
  };

  useEffect(() => {
    transactionType();
    payeeApi();
    accountsApi();
  }, []);

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      selectTransaction,
      beginningDate,
      finalDate,
      selectCustomer,
      selectSupplier,
      selectEmployee,
      sortingId, //currentorder
      sortingDirection, //ordercolumn,
      searchtext,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      textFieldsData,
      accountId,
      itemIds
    );
  }, [
    selectTransaction,
    beginningDate,
    finalDate,
    selectCustomer,
    selectSupplier,
    selectEmployee,
    searchtext, //
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    textFieldsData,
    accountId,
    itemIds,
  ]);

  // const SupplierAPI = () => {
  //   axios
  //     .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })
  //     .then((response) => {
  //       // setSupplier([
  //       //   { FirstName: "Select Supplier", ID: 0 },
  //       //   ...response.data.ResponseData,
  //       // ]);
  //       setSupplier(response.data.ResponseData);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const CustomerAPI = () => {
  //   axios
  //     .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       // setLoading(true);
  //       setCustomer(res.data.ResponseData);
  //       // setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const EmployeesAPI = () => {
  //   axios
  //     .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res.data.ResponseData, "setEmployees");
  //       // setLoading(true);
  //       setEmployees(res.data.ResponseData);
  //       // setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const transactionType = () => {
    //payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=4`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setTransactionTypeDropdown(res.data.ResponseData);
        // console.log("res280", res.data.ResponseData);
      });
  };

  const payeeApi = () => {
    axios
      .get(
        `${config.appointmentBaseUrl}/appointments/appointmentpersonddl/?isCustomer=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setPayee(res.data.ResponseData);
      });
  };

  const accountsApi = () => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        setAccountsList(res.data.ResponseData);
      });
  };

  // const paymentDetailsAPI = () =>{

  // }

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     selectTransaction,
  //     beginningDate,
  //     finalDate,
  //     selectCustomer,
  //     selectSupplier,
  //     e.id, //currentorder
  //     sortingDirection, //ordercolumn,
  //     searchtext
  //   );
  // };

  const handleListData = (
    pagenumber,
    pagesize,
    transactiontype,
    beginningDate,
    finalDate,
    customerid,
    supplierid,
    Employeesid,
    currentorder,
    ordercolumn,
    searchtext,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    beginningDate =
      beginningDate == undefined
        ? ""
        : beginningDate == null
        ? ""
        : beginningDate;
    finalDate =
      finalDate == undefined ? "" : finalDate == null ? "" : finalDate;

    console.log("angel", columnFilters, globalFilter, pagination, sorting);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    setLoading(true);
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/transactionpaymentlog?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&transactiontype=${transactiontype}&supplierid=${supplierid}&customerid=${customerid}&Employeesid=${Employeesid}&locationid=${locationId}&startdate=${beginningDate}&enddate=${finalDate}&loginId=${loginuserid}&referenceno=${
          textFieldsData.refrenceno
        }&amount=${textFieldsData.Amount}&conditionid=${conditionId}&memo=${
          textFieldsData.Memo
        }&accountid=${accountId}&itemid=${itemIds.ItemId}&variationid=${
          itemIds.variationId
        }&maxamount=${textFieldsData.maxamount}&isFirstTimeCall=${isFirstTimeCall}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("uis here", res);
        setIsFirstTimeCall(0);
        navigate("/transaction-log");
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setFormValues(res.data.ResponseData?.list);


        // setData(res.data.ResponseData?.list);

      //   const filteredData = res.data.ResponseData?.list?.filter(
      //   (item) => (item.Type === "Expense" && checkUserPermission(SHOWEXPENSE)) ||
      //             (item.Type === "Deposit" && checkUserPermission(SHOWDEPOSITS)) ||
      //             (item.Type === "Receive Payment" && checkUserPermission(SHOWPAYMENTS)) ||
      //             (item.Type === "Bill Payment" && checkUserPermission(SHOWPAYBILLS)) ||
      //             (item.Type === "Journal" && checkUserPermission(SHOWJOURNALS)) ||
      //             (item.Type === "Transfer" && checkUserPermission(SHOWBANKTRANSFER)) 
      // );
      // setData(filteredData);
      const filteredData = res.data.ResponseData?.list?.filter((item) => {
        if (item.Type === "Expense") {
          return checkUserPermission(SHOWEXPENSE);
        }
        if (item.Type === "Deposit") {
          return checkUserPermission(SHOWDEPOSITS);
        }
        if (item.Type === "Receive Payment") {
          return checkUserPermission(SHOWPAYMENTS);
        }
        if (item.Type === "Bill Payment") {
          return checkUserPermission(SHOWPAYBILLS);
        }
        if (item.Type === "Journal") {
          return checkUserPermission(SHOWJOURNALS);
        }
        if (item.Type === "Transfer") {
          return checkUserPermission(SHOWBANKTRANSFER);
        }
        
        // Allow all other items (not in the above restricted list)
        return true;
      });

      setData(filteredData);


        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  //Supplier Dropdown
  let supplierTypeDropdownOption = [];
  const termpsupplierlist = supplier.filter((u, i) => {
    supplierTypeDropdownOption[i] = {
      // label: u.FirstName,
      label: u.CompanyName,
      // + " (" + (u.FirstName + " " + u.LastName) + ")"
      value: u.ID,
    };
  });

  let appointmentPersonOptions = [];
  let UserType = [];
  const Person = payee.map((u, i) => {
    if (u.IsCustomer == 1) {
      UserType = "Customer";
    } else if (u.IsCustomer == 0) {
      UserType = "Supplier";
    } else {
      UserType = "Employee";
    }
    appointmentPersonOptions[i] = {
      label: u.FirstName + " " + `   (${UserType})`,
      value: u.Id,
      IsCustomer: u.IsCustomer,
      QuickbookId: u.QuickBookId,
    };
  });

  let accountOptions = [];
  const getaccounts = accountslist.map((u, i) => {
    accountOptions[i] = { label: u.Name, value: u.ID,parentName: u.ParentName ? u.ParentName.trim() : "",
            AccountType: u.AccountType, };
  });

  //Customer Dropdown
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      label: u.CompanyName,
      // + " (" + (u.FirstName + " " + u.LastName) + ")"
      value: u.Id,
    };
  });

  let EmployeesOption = [];
  const EmployeesDropdown = Employees.map((u, i) => {
    EmployeesOption[i] = {
      label: u.Name,
      value: u.eID,
    };
  });
  //TransactionType Dropdown
  // let transactionTypeDropdownOption = [];
  // const transactionDropdown = transactionTypeDropdown?.map((u, i) => {
  //   transactionTypeDropdownOption[i] = {
  //     label: u.Name,
  //     value: u.ID,
  //   };
  // });

  let transactionTypeDropdownOption = transactionTypeDropdown
  ?.filter((type) => {
    const path = transactionTypeToPermissionMap[type.Name.trim()];
    return path ? checkUserPermission(path) : true; // if not in map, allow by default
  })
  .map((type) => ({
    label: type.Name.trim(),
    value: type.ID,
  }));

  const selectTransactionHandle = async (event) => {
    console.log(event, "584event value after click");
    setSelectTransaction(event == undefined ? 1 : event);
  };

  const radioClickSupplierHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");

    setShowCustomerSelect(false);
    setShowSupplierSelect(true);
    setShowEmployeeSelect(false);
  };

  const radioClickempolyeHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");

    setShowCustomerSelect(false);
    setShowSupplierSelect(false);
    setShowEmployeeSelect(true);
  };
  const radioClickCustomerHandle = async (event) => {
    console.log(event.target.checked, "click Supplier radio");
    setShowSupplierSelect(false);
    setShowCustomerSelect(true);
    setShowEmployeeSelect(false);
  };

  const selectSupplierHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectSupplier(event == undefined ? 0 : event);
    setSelectCustomer(0);
    setSelectEmployee(0);
  };

  const selectCustomerHandle = async (event) => {
    console.log(event, "event value after click");
    setSelectCustomer(event == undefined ? 0 : event);
    setSelectSupplier(0);
    setSelectEmployee(0);
  };

  const selectContactHandle = (event) => {
    console.log(event, "event value after click");
    if (event) {
      if (event.IsCustomer === 2) {
        setSelectEmployee(event.value);
        setSelectCustomer(0);
        setSelectSupplier(0);
      } else if (event.IsCustomer === 0) {
        setSelectSupplier(event.value);
        setSelectEmployee(0);
        setSelectCustomer(0);
      } else if (event.IsCustomer === 1) {
        setSelectCustomer(event.value);
        setSelectSupplier(0);
        setSelectEmployee(0);
      }

      setSelectedPayee({
        value: event.value,
        payeeType: event.IsCustomer,
      });
    } else {
      setSelectSupplier(0);
      setSelectEmployee(0);
      setSelectCustomer(0);
      setSelectedPayee({
        value: 0,
        payeeType: 0,
      });
    }
  };

  const handleAccount = (event) => {
    if (event) {
      setAccountId(event.value);
    } else {
      setAccountId(0);
    }
  };

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationId}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          const modifiedData = res.data.ResponseData.map((item) => ({
            ...item,
            ID: item.ItemId,
            VariationId: item.VariationId,
            Name: item.VariationName != "" ? item.VariationName : item.ItemName,
            ImageURL: item.ImageName,
            Quantity:
              item.VariationId != 0
                ? item.VariationQuantity
                : item.Itemquantity,
            Categoryfullpath: item.CategoryName,
          }));
          setSuggestions(modifiedData);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  const handleInputClick = (item) => {
    console.log(item, "itemitem");
    setSearchItemName("");
    setItemIds({
      ItemId: item.ItemId,
      variationId: item.VariationId,
      itemName: item.VariationId > 0 ? item.VariationName : item.ItemName,
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  const handleChangeTextFields = (event, type) => {
    console.log(event.target.value, type, "checkfieldsdata");
    if (type === "referenceno") {
      setTextFieldsData({ ...textFieldsData, refrenceno: event.target.value });
    } else if (type === "memo") {
      setTextFieldsData({ ...textFieldsData, Memo: event.target.value });
    } else if (type === "Amount") {
      setTextFieldsData({ ...textFieldsData, Amount: event.target.value });
    } else if (type === "maxAmount") {
      setTextFieldsData({ ...textFieldsData, maxamount: event.target.value });
    }
  };

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     selectTransaction,
  //     beginningDate,
  //     finalDate,
  //     selectCustomer,
  //     selectSupplier,
  //     sortingId, //currentorder
  //     sortingDirection, //ordercolumn
  //     searchtext
  //   );
  // };

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_Report.xlsx`);
  };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     selectTransaction,
  //     beginningDate,
  //     finalDate,
  //     selectCustomer,
  //     selectSupplier,
  //     sortingId, //currentorder
  //     sortingDirection, //ordercolumn
  //     searchtext
  //   );
  // };

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  console.log(data, "data==>");

  const downloadPDF = (rows, field) => {
    setLoading(true);

    let newData = [];
    if (field === "selectedRow") {
      newData = rows.map((row) => row.original);
    } else if (field === "allData") {
      newData = data;
    }

    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(newData.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            newData[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(newData[index - 1].DueDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(newData[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(newData[index - 1].LastModifiedDate).format("YYYY-MM-DD") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("pdf.pdf");
        setLoading(false);
      },
    });
  };

  const onBtPrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = 37;

    for (var i = 1; i <= Math.ceil(data.length / 37); i++) {
      if (i > 1) {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1.5rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      } else {
        content +=
          '<div style="width: 560px; text-align: center; margin: 0; margin-top: 1rem"> ' +
          '<p style="font-size: 12px; margin: 0; font-weight: bold">' +
          "Transaction Log" +
          "</p>" +
          '<p style="font-size: 10px; margin: 0; margin-top: 0.5rem">';

        if (beginningDate) {
          content += "From: " + beginningDate + " ";
          if (finalDate !== "") {
            content += "To: " + finalDate + " ";
          }
        } else {
          content += "All Data";
        }
      }

      content += "</p>" + "</div>";

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 5px;">Sr.No.</th>' +
        '<th style="padding: 5px;">Date</th>' +
        '<th style="padding: 5px;">Type</th>' +
        '<th style="padding: 5px; text-align: right;">NO.</th>' +
        '<th style="padding: 5px;">Contact</th>' +
        '<th style="padding: 5px;">Memo/Desc</th>' +
        '<th style="padding: 5px; text-align: right;">Due Date</th>' +
        '<th style="padding: 5px; text-align: right;">Amount</th>' +
        '<th style="padding: 5px; text-align: right;">Last Modified Date</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            index +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].Date).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Type +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].No).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Contact +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            data[index - 1].Memo +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px;">' +
            moment(data[index - 1].DueDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 6px; padding: 5px; text-align: right;">' +
            moment(data[index - 1].LastModifiedDate).format("YYYY-MM-DD") +
            "</td>" +
            "</tr>";
        }

        if (index % 37 == 0) {
          startIndex = startIndex + 37;
          endIndex = endIndex + 37;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const handleexcelexport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formValues);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Transactionlog_details_.xlsx`);
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `SalesbyCustomerDetail_.xlsx`);
  };

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission("edit-transaction-log") &&
    row?.original?.Module === "SALES" ? (
      <MenuItem
        onClick={
          () =>
            navigate(
              isManageSale == 1
                ? `/manage-sales/${row.original.ID}`
                : isManagePOSSale == 1
                ? `/pos/${row.original.ID}`
                : "#"
            )
          // navigate(`/manage-sales/${row.original.ID}`)
        }
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "RECEIVINGS" && row?.original?.Type !=  "Expense"? (
      <MenuItem
        // onClick={() => navigate(`/manage-receiving/${row.original.ID}`)}
        onClick={() => navigate(
          // row.original?.Type === "Expense" ? `/Expense/${row.original.ID}`
          // :
          isManageReceiving == 1
            ? `/manage-receiving/${row.original.ID}`
            : isManagePOSReceiving == 1
            ? `/pos-receiving/${row.original.ID}`
            : "#"
        )}
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "DEPOSIT" && checkUserPermission(EDITDEPOSITS) ? (
      <MenuItem onClick={() => navigate(`/bank-deposit/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "TRANSFER" && checkUserPermission(EDITBANKTRANSFER) ? (
      <MenuItem onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "JOURNAL" && checkUserPermission(EDITJOURNALS) ? (
      <MenuItem onClick={() => navigate(`/journal-entry/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : row?.original?.Module === "RECEIVINGS" && row?.original?.Type ===  "Expense" && checkUserPermission(EDITEXPENSE) ? (
      <MenuItem
        onClick={() => navigate(`/Expense/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "PAYBILLS" && checkUserPermission(EDITPAYBILLS) ? (
      <MenuItem
        onClick={() => navigate(`/receiving-paybills/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : row?.original?.Module === "RECEIVEPAYMENT" && checkUserPermission(EDITPAYMENTS) ? (
      <MenuItem onClick={() => navigate(`/receive-payment/${row.original.ID}`)}>
        Edit
      </MenuItem>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) &&
        (checkUserPermission("mark-inactive") ? (
          <Button
            // size="small"
            class="btn btn-sm btn-secondary"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            //only export selected rows
            onClick={() =>
              handleDeletePopup(
                "",
                "",
                table.getSelectedRowModel().rows,
                "multipleRowInactive"
              )
            }
            // startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Mark InActive
          </Button>
        ) : (
          " "
        ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  console.log(loading, "data1039");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          {/* Header Scetion */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Accounting: Transaction Log</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Transaction Log</li>
              </ul>
            </div>
            {/* export Print arrange Columns */}
          </div>

          {/* Filter Section */}
          <div className="card">
            <div className="card-body">
              {/* First Row */}
              {/* 1st Filter */}
              <div
                className="col-md-12 d-flex flex-wrap gap-2"
                // style={{ display: "flex", gap: "1rem" }}
              >
                {/* Date Filter */}
                {/* style={{ width: "fit-content" }} */}
                <div className=" col-md-2">
                  <div className=" col-form-label"> Date </div>
                  <Select
                    onChange={(event) => {
                      handleDateFilter(event);
                    }}
                    options={dateOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    // hideSelectedOptions={true}
                    // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    value={dateOptions.find((el) => el?.value == customeDate)}
                    isOptionDisabled={(option) => option.value == 0}
                    className="custom-search-select"
                  />
                </div>
                {/* From Date */}
                {customeDate === 7 && (
                  <div className="col-md-2">
                    <div className=" col-form-label"> From </div>
                    <CommonDatePicker
                      FinalDate={beginningDate}
                      handleDateChange={handleDate}
                    />
                  </div>
                )}

                {/* To Date */}
                {customeDate === 7 && (
                  <div className="col-md-2">
                    <div className=" col-form-label">To </div>
                    <CommonDatePicker
                      FinalDate={finalDate}
                      handleDateChange={handleEndDate}
                    />
                  </div>
                )}

                <div className="col-md-2">
                  <div className=" col-form-label">Transaction Type</div>
                  <Select
                    options={transactionTypeDropdownOption}
                    value={transactionTypeDropdownOption.find(
                      (option) => option?.value == selectTransaction
                    )}
                    onChange={(event) => {
                      selectTransactionHandle(event?.value);
                    }}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="Transaction"
                    name="Transaction"
                    className="custom-search-select"
                  />
                </div>
                <div className="col-md-2">
                  <div className=" col-form-label">Reference number</div>
                  <input
                    type="text"
                    id="referenceno"
                    name="referenceno"
                    placeholder="reference no."
                    className="form-control form-control-sm"
                    isClearable={true}
                    value={textFieldsData.refrenceno}
                    onChange={(event) => {
                      handleChangeTextFields(event, "referenceno");
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <div className=" col-form-label">Contact</div>
                  <Select
                    options={appointmentPersonOptions}
                    value={
                      appointmentPersonOptions
                        .filter(
                          (option) =>
                            option?.IsCustomer === selectedPayee.payeeType
                        ) // Filter by the desired type
                        .find((option) => option?.value === selectedPayee.value) // Find the matching value within the filtered options
                    }
                    // value={appointmentPersonOptions.find(
                    //   (option) => option?.value == selectedPayee.value
                    // )}
                    onChange={(event) => {
                      selectContactHandle(event);
                    }}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="contact"
                    name="contact"
                    className="custom-search-select"
                  />
                </div>
                <div className="col-md-2">
                  <div className=" col-form-label">{""}</div>
                  {/* <button
                    className="btn btn-sm btn-outline-dark mt-4"
                    onClick={() =>
                      setShowMoreFilters(showMoreFilters === 0 ? 1 : 0)
                    }
                  >
                    More Filters <i class="fa fa-filter"></i>
                  </button> */}
                  <div className="item col-auto ms-3" title="Advance Filter">
                    <Link
                      className="btn btn-sm btn-outline-dark mt-4"
                      onClick={() => {
                        setShowMoreFilters(!showMoreFilters);
                      }}
                    >
                      {showMoreFilters ? (
                        <i className="fa fa-arrow-up me-2 ms-2 mt-3"></i>
                      ) : (
                        <i className="fa fa-arrow-down me-2 ms-2 mt-2"></i>
                      )}
                    </Link>
                  </div>
                </div>
                {showMoreFilters && (
                  <>
                    <div className="col-md-2">
                      <div className=" col-form-label">Amount</div>
                      <div className="dropdown d-flex">
                        {/* <input
                          type="text"
                          id="amount"
                          name="amount"
                          placeholder="Amount"
                          onChange={(event) => {
                            handleChangeTextFields(event, "amount");
                          }}
                          value={textFieldsData.Amount}
                          style={{
                            border: "1px solid #a3a3a3",
                            width: "85%",
                            borderBottomLeftRadius: "8px",
                            borderTopLeftRadius: "8px",
                            paddingLeft:"4px"
                          }}
                        /> */}
                        <>
                          {conditionId === 2 ? (
                            <>
                              <input
                                type="text"
                                id="min-amount"
                                name="min-amount"
                                placeholder="min"
                                onChange={(event) => {
                                  handleChangeTextFields(event, "Amount");
                                }}
                                value={textFieldsData.Amount || ""}
                                style={{
                                  border: "1px solid #a3a3a3",
                                  width: "85%",
                                  borderBottomLeftRadius: "8px",
                                  borderTopLeftRadius: "8px",
                                  paddingLeft: "8px",
                                }}
                              />
                              <input
                                type="text"
                                id="max-amount"
                                name="max-amount"
                                placeholder="max"
                                onChange={(event) => {
                                  handleChangeTextFields(event, "maxAmount");
                                }}
                                value={textFieldsData.maxamount || ""}
                                style={{
                                  border: "1px solid #a3a3a3",
                                  width: "85%",
                                  // borderBottomLeftRadius: "8px",
                                  // borderTopLeftRadius: "8px",
                                  paddingLeft: "8px",
                                }}
                              />
                            </>
                          ) : (
                            <input
                              type="text"
                              id="amount"
                              name="amount"
                              placeholder="amount"
                              onChange={(event) => {
                                handleChangeTextFields(event, "Amount");
                              }}
                              value={textFieldsData.Amount || ""}
                              style={{
                                border: "1px solid #a3a3a3",
                                width: "85%",
                                borderBottomLeftRadius: "8px",
                                borderTopLeftRadius: "8px",
                                paddingLeft: "8px",
                              }}
                            />
                          )}
                        </>

                        {/* Middle div triggering the dropdown */}
                        <div
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="border-radius-pos-toggle-arrow dropdown-toggle toggle-specified-height"
                          style={{
                            border: "1px solid #a3a3a3",
                            borderTopRightRadius: "8px",
                            borderTopRightRadius: "8px",
                          }}
                          // onClick={(e) => e.preventDefault()}
                        ></div>

                        {/* Dropdown menu */}
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 1 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(1)}
                            >
                              Equals
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 2 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(2)}
                            >
                              Between
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 3 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(3)}
                            >
                              Greater than
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 4 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(4)}
                            >
                              Greater than or equals
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 5 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(5)}
                            >
                              Less than
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={`dropdown-item ${
                                conditionId === 6 ? "active" : ""
                              }`}
                              onClick={() => setConditionId(6)}
                            >
                              Less than or Equals
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className=" col-form-label">Memo</div>
                      <input
                        type="text"
                        id="memo"
                        name="memo"
                        placeholder="memo"
                        className="form-control form-control-sm"
                        onChange={(event) => {
                          handleChangeTextFields(event, "memo");
                        }}
                        value={textFieldsData.Memo}
                      />
                    </div>
                    <div className="col-md-4">
                      <div className=" col-form-label">Accounts</div>
                      <Select
                        onChange={(event) => handleAccount(event)}
                        options={accountOptions}
                        backspaceRemovesValue={false}
                        isClearable={true}
                        controlShouldRenderValue={true}
                        id="AccountIDs"
                        name="AccountIDs"
                        value={accountOptions.find(
                          (item, index) => item.value == accountId
                        )}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        formatOptionLabel={({ label, parentName, AccountType }) => (
                          <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <span>{label}</span>
                            <span style={{ fontStyle: "italic", color: "#666", marginLeft: "1rem" }}>
                              {parentName ? `Sub-account of ${parentName}` : AccountType}
                            </span>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-md-5">
                      <div className=" col-form-label">Items</div>
                      <div>
                        <input
                          type="search"
                          placeholder="Search..."
                          className="search-btn form-control form-control-sm"
                          onChange={(e) => {
                            setSearchItemName(e.target.value);
                          }}
                          value={searchItemName}
                          style={{ width: "300px" }}
                        />
                        {itemIds.itemName && (
                          <>
                            ({itemIds.itemName})
                            <button
                              onClick={() => {
                                setItemIds({
                                  ItemId: 0,
                                  variationId: 0,
                                  itemName: "",
                                });
                              }}
                            >
                              <i class="fa fa-remove"></i>
                            </button>
                          </>
                        )}
                        {suggestions?.length > 0 ? (
                          <>
                            <div className="dropdown">
                              <ul
                                className="dropdown-menu show dropdown-suggestion"
                                style={{
                                  overflow: "auto",
                                  width: "120% ",
                                  maxWidth: "600px",
                                }}
                              >
                                {suggestions?.map((item) => (
                                  <li
                                    className="border-bottom"
                                    key={item.ID}
                                    onClick={(e) => handleInputClick(item)}
                                  >
                                    <Link
                                      key={item.ID}
                                      href="#"
                                      class="dropdown-item"
                                      data-name={item.Name?.toLowerCase()}
                                    >
                                      <img
                                        src={item.ImageURL || Noimage}
                                        onError={(e) => {
                                          e.currentTarget.src = Noimage;
                                        }}
                                        alt={item.Name}
                                        className="img-thumbnail rounded-circle mr-4"
                                        width="55"
                                        height="55"
                                        style={{
                                          height: "60px",
                                          objectFit: "contain",
                                        }}
                                      />
                                      <div className="customer-info w-100">
                                        <strong
                                          className="word-break-data"
                                          style={{
                                            fontWeight: "bold",
                                            color: "#333",
                                          }}
                                        >
                                          {item.Name}{" "}
                                          {item.Name ? `(${item.Name})` : ""}
                                        </strong>
                                      </div>
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </>
                )}

                {/* <div className="col-md-2">
                    <div className="col-form-label">
                      <input
                        type="radio"
                        onClick={(e) => radioClickSupplierHandle(e)}
                        checked={showSupplierSelect}
                        style={{ fontSize: "1rem" }}
                      />{" "}
                      Supplier
                    </div>

                    <div className="col-form-label">
                      <input
                        type="radio"
                        onClick={(e) => radioClickCustomerHandle(e)}
                        checked={showCustomerSelect}
                        style={{ fontSize: "1rem" }}
                      />{" "}
                      Customer
                    </div>

                    {selectTransaction == 6 && (
                      <div className="col-form-label">
                        <input
                          type="radio"
                          onClick={(e) => radioClickempolyeHandle(e)}
                          checked={ShowEmployeeSelect}
                          style={{ fontSize: "1rem" }}
                        />{" "}
                        Employees
                      </div>
                    )}
                  </div> */}

                {/* Supplier Filter */}
                {/* {showSupplierSelect && (
                    <div className="col-md-3">
                      <div className="col-form-label"> Supplier </div>
                      <Select
                        options={supplierTypeDropdownOption}
                        value={supplierTypeDropdownOption.find(
                          (option) => option?.value == selectSupplier
                        )}
                        onChange={(event) => {
                          selectSupplierHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                      />
                    </div>
                  )} */}

                {/* Customer Filter */}
                {/* {showCustomerSelect && (
                    <div className="col-md-3">
                      <div className=" col-form-label">Customer</div>
                      <Select
                        options={customerOption}
                        value={customerOption.find(
                          (option) => option?.value == selectCustomer
                        )}
                        onChange={(event) => {
                          selectCustomerHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Supplier"
                        name="Supplier"
                        className="custom-search-select"
                      />
                    </div>
                  )} */}

                {/* {ShowEmployeeSelect && (
                    <div className="col-md-3">
                      <div className=" col-form-label">Employees</div>
                      <Select
                        options={EmployeesOption}
                        value={EmployeesOption.find(
                          (option) => option?.value == selectEmployee
                        )}
                        onChange={(event) => {
                          selectEmployeeHandle(event?.value);
                        }}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="Employees"
                        name="Employees"
                        className="custom-search-select"
                      />
                    </div>
                  )} */}
              </div>
            </div>
          </div>

          {/* Data Table  */}
          <div className="card">
            <div className="card-body">
              <div
                className="row"
                style={{
                  margin: "10px",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "16px",
                  }}
                  className="col-md-8"
                >
                  <div>
                    Search:{" "}
                    {
                      transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )?.label
                    }
                  </div>
                  <div>
                    {formValues?.length > 0 ? (
                      <> Found {formValues[0]?.TotalRecord} matches.</>
                    ) : (
                      "No items found."
                    )}
                  </div>
                  <div>
                    {beginningDate && (
                      <>
                        From: {moment(beginningDate).format(`${dateFormate.toUpperCase()}`)}{" "}
                        {finalDate != "" && (
                          <>To: {moment(finalDate).format(`${dateFormate.toUpperCase()}`)}</>
                        )}{" "}
                      </>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    alignItems: "center",
                  }}
                  className="col-md-4"
                >
                  {checkUserPermission("export-button") ? (
                    <button
                      className="btn btn-sm btn-outline-dark btn-sm mt-3"
                      style={{ width: "max-content" }}
                      onClick={() => onBtExport([], "AllData")}
                    >
                      <i
                        className="fa fa-download mr-2"
                        style={{ color: "#111930" }}
                      ></i>
                      Export Visible Column
                    </button>
                  ) : (
                    ""
                  )}

                  <div
                    className="cursor-pointer mt-3 mr-3"
                    onClick={() =>
                      handleSaveColumnOrder(
                        loginuserid,
                        "TransactionLog",
                        columnOrder,
                        token,
                        columnVisibility
                      )
                    }
                    title="Lock Your Sequence"
                  >
                    <i class="fa fa-lock columnsLock fs-4"></i>
                  </div>
                </div>
              </div>

              <div style={{ position: "relative", zIndex: "0" }}>
                <CommonMatrialReactTableServerSideRender
                  MainHeading="Sonar POS"
                  ReportHeading="Payment List"
                  columns={columns}
                  data={data}
                  // startdate={startdate}
                  // enddate={enddate}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  enableRowActions={checkUserPermission(PERMISSION_EDIT)}
                  enableRowSelection={true}
                  renderRowActionMenuItems={renderRowActionMenuItems}
                  renderTopToolbarCustomActions={renderTopToolbarCustomActions}
                  density="compact"
                  showGlobalFilter={true}
                  showColumnFilters={false}
                  expanded={true}
                  pagination={{ pageIndex: 0, pageSize: 25 }}
                  rowCount={rowCount}
                  setColumnFilters={setColumnFilters} // for termp comment filteron column
                  setGlobalFilter={setGlobalFilter}
                  setPagination={setPagination}
                  setSorting={setSorting}
                  setColumnOrder={setColumnOrder}
                  setColumnVisibility={setColumnVisibility} //setColumnVisibility
                  state={{
                    columnFilters, // for termp comment filteron column
                    // globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                    columnOrder,
                    columnVisibility,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentLog;
